import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcpInputComponent } from './fcp-input.component';
import { FcpFormFieldModule } from '../fcp-form-field/fcp-form-field.module';

@NgModule({
    declarations: [FcpInputComponent],
    imports: [CommonModule, FcpFormFieldModule],
    exports: [FcpFormFieldModule, FcpInputComponent]
})
export class FcpInputModule {}
